var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 93,
    viewBox: "0 0 103 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_613_730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 93
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 92.0941,
    rx: 8,
    fill: "#E47100"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_613_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5408 25.423C88.5408 52.9373 103 71.8318 103 85.0898C103 98.3478 95.268 126.196 33.3916 126.196C-28.4848 126.196 -37.5647 88.7374 -37.5647 74.1549C-37.5687 5.86816 88.5408 -23.3049 88.5408 25.423Z",
    fill: "#FBEFE4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionBg);
export default __webpack_public_path__ + "static/media/TransactionBg.053a64bc16e6876499232b5e19ee1527.svg";
export { ForwardRef as ReactComponent };